import { transactionTypePositionCheck } from '../utils/helper';

const normalizeValue = (value) => {
  if (value == null || String(value).trim() === '') {
    return null;
  }

  return String(value).trim().toLowerCase();
};

const getSellerVatCompanyId = (root) => {
  const party = root?.accounting_supplier_party;

  return party?.party_tax_scheme?.company_id;
};

const valuesMatch = (sellerVat, principalId) => {
  const normalizedSellerVat = normalizeValue(sellerVat);
  const normalizedPrincipalId = normalizeValue(principalId);

  if (normalizedSellerVat == null || normalizedPrincipalId == null) {
    return false;
  }

  return normalizedSellerVat === normalizedPrincipalId;
};

export const createAgentBillingDistinctnessTest = (isPurchase = false) =>
  function agentBillingDistinctness(value) {
    const root = this.parent;

    if (!transactionTypePositionCheck(root?.profile_execution_id, 6)) {
      return true;
    }

    const sellerVat = getSellerVatCompanyId(root);

    return !valuesMatch(sellerVat, value);
  };

export const createAgentBillingPartyDistinctnessTest = (isPurchase = false) =>
  function agentBillingPartyDistinctness(value) {
    const root = this.parent;

    if (!transactionTypePositionCheck(root?.profile_execution_id, 6)) {
      return true;
    }

    const sellerVat = value?.party_tax_scheme?.company_id;

    return !valuesMatch(sellerVat, root?.principle_id_trn);
  };
